<template>
    <div style="height:100%">
        <div id="china_map" ref="ChinaEchart" style="width: 100%; background:#A8A8A8;"></div>
        <div class="info">
            <div class="left-ball"></div>
            <div class="right-ball"></div>
            <div class="title">{{$t('warehouse1.title2')}}</div>
            <div v-if="$i18n.locale == 'zh'" class="card-box">
                <div class="item" v-for="(item,index) in dataList" :key="index" v-if="item.content">
                    <img :src="dataList[index].image">
                    <div style="font-size:22px;margin-bottom:10px">{{dataList[index].name}}</div>
                    <div style="display: flex;">
                        <img src="../../assets/images/icon-jian.png" style="width:19px;height:19px;margin-right:16px;margin-top:3px">
                        <div v-html="dataList[index].content" style="font-size:18px;" class="zh-font"></div>
                    </div>
                </div>
            </div>
            <div class="card-box" v-if="$i18n.locale == 'en'" >
                <div class="item" v-for="(item,index) in dataList" :key="index" v-if="item.content">
                    <img :src="dataList[index].image">
                    <div style="font-size:20px;font-family:'Lato-Bold';margin-bottom:10px">{{dataList[index].enName}}</div>
                    <div style="display: flex">
                        <img src="../../assets/images/icon-jian.png" style="width:19px;height:19px;margin-right:16px;margin-top:3px">
                        <div v-html="dataList[index].enContent" style="font-size:18px;font-family:'Lato'"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import echarts from "echarts"
import '../../../node_modules/echarts/map/js/china.js' //引入中国地图
export default ({
    watch:{
        '$i18n.locale':function(newLang,oldLang){
            this.lang = newLang
            this.initMap()
        }
    },
    data() {
        return {
        lang: 'zh',
            //echart 配制option  
        options:{},
        dataList: [
        {
            name: "上海",
            enName: "Shanghai",
            label: {
                normal: {
                    position: 'right',
                    offset:[-2,0]
                }
            },
            value: [121.504642,31.24186],
            content: "甲类 1,200+m²<br/>乙类 5,200+m²<br/>丙类 9,200m²",
            enContent: "Class A 1,200+m²<br/>Class B 5,200+m²<br/>Class C 9,200m²",
            image: require("../../assets/images/shanghaiwei1.png"),
            image1: require("../../assets/images/shanghaiwei.png")
        },
        {
            name: "沧州",
            enName: "Cangzhou",
            label: {
                normal: {
                    position: 'left',
                    offset:[0,0]
                }
            },
            value: [116.856207,38.286513],
            content: "甲类 8,056+m²<br/>乙类 21,068.75m²",
            enContent: "Class A 8,056+m²<br/>Class B 21,068.75m²",
            image: require("../../assets/images/cangzhouwei1.png"),
            image1: require("../../assets/images/cangzhouwei.png")
        },
        {
            name: "成都",
            label: {
                normal: {
                    position: 'bottom',
                    offset:[0,-10]
                }
            },
            enName: "Chengdu",
            value: [104.104733,30.652319],
            content:"甲类 4,000+m²<br/>乙类 23,000+m²",
            enContent:"Class A 4,000+m²<br/>Class B 23,000+m²",
            image: require("../../assets/images/chengduwei1.png"),
            image1: require("../../assets/images/chengduwei.png")
        },
        {
            name: "合肥",
            enName: "Hefei",
            label: {
                normal: {
                    position: 'bottom',
                    offset:[0,-10]
                }
            },
            value: [117.240898,31.838583],
            content:"甲类 1,800+m²<br/>乙类 2,200+m²",
            enContent:"Class A 1,800+m²<br/>Class B 2,200+m²",
            image: require("../../assets/images/hefeiwei1.png"),
            image1: require("../../assets/images/hefeiwei.png")
        },
        {
            name: "武汉",
            label: {
                normal: {
                    position: 'bottom',
                    offset:[0,-10]
                }
            },
            enName: "Wuhan",
            value: [114.338531,30.558876],
            // content:"甲类 50 m²<br/>乙类 100 m²<br/>丙类 300 m²",
            // enContent:"Class A 1,000+ m²<br/>Class B 1,000+ m²<br/>Class C 4,000+ m²",
            image: require("../../assets/images/wuhanwei1.png"),
            image1: require("../../assets/images/wuhanwei.png")
        },
        {
            name: "东莞",
            enName: "Dongguan",
            value: [113.745411,23.019925],
            content:"甲类 32,940m²<br/>乙类 35,650m²<br/>丙类 16,000m²",
            enContent: "Class A 32,940m²<br/>Class B 35,650m²<br/>Class C 16,000m²",
            image: require("../../assets/images/dongguanwei.png"),
            image1: require("../../assets/images/dongguanwei1.png")
        },
        // {
        //     name: "重庆",
        //     label: {
        //         normal: {
        //             position: 'bottom',
        //             offset:[0,-10]
        //         }
        //     },
        //     enName: "Chongqing",
        //     value: [106.487678,29.541249],
        //     content:"甲类 4,000 m²<br/>乙类 10,000 m²<br/>丙类 16,000 m²",
        //     enContent:"Class A 4,000 m²<br/>Class B 10,000 m²<br/>Class C 16,000 m²",
        //     image: require("../../assets/images/chongqingwei1.png"),
        //     image1: require("../../assets/images/chongqingwei.png"),
        // },
        {
            name: "张家港",
            enName: "Zhangjiagang",
            label: {
                normal: {
                    position: 'top',
                    offset:[0,10]
                }
            },
            value: [120.520216,31.856251],
            content:"甲类 9,000+m²<br/>乙类 16,000+m²",
            enContent:"Class A 9,000+m²<br/>Class B 16,000+m²",
            image: require("../../assets/images/zhangjiawei1.png"),
            image1: require("../../assets/images/zhangjiawei.png")
        },
        // {
        //     name: "济南",
        //     enName: "Jinan",
        //     label: {
        //         normal: {
        //             position: 'bottom',
        //             offset:[0,-10]
        //         }
        //     },
        //     value: [117.112117,36.64872],
        //     content:"丙类 1,400+ m²",
        //     enContent:"Class C 1,400+ m²",
        //     image: require("../../assets/images/jinanwei1.png"),
        //     image1: require("../../assets/images/jinanwei.png")
        // },
        {
            name: "廊坊",
            enName: "Langfang",
            value: [116.717023,39.516431],
            label: {
                normal: {
                    position: 'left',
                    offset: [0,0]
                }
            },
            content: "甲类 500m²<br/>乙类 1,500m²",
            enContent: "Class A 500m²<br/>Class B 1,500m²",
            image: require("../../assets/images/langfangwei1.png"),
            image1: require("../../assets/images/langfangwei.png")
        },
        {
            name: "天津",
            enName: "Tianjin",
            value: [117.220915,39.116983],
            label: {
                normal: {
                    position: 'top',
                    offset: [0,0]
                }
            },
            content: "乙类 1,000m²<br/>丙类 4,000m²",
            enContent: "Class B 1,000m²<br/>Class C 4,000m²",
            image: require("../../assets/images/tianjinwei1.png"),
            image1: require("../../assets/images/tianjinwei.png")
        },
        {
            name: "淄博",
            enName: "Zibo",
            value: [118.054407,36.780916],
            label: {
                normal: {
                    position: 'right',
                    offset: [0,0]
                }
            }
        },
        {
            name: "厦门",
            enName: "Xiamen",
            value: [118.096089,24.484935],
            label: {
                normal: {
                    position: 'top',
                    offset: [0,10]
                }
            }
        },
        ]
        }
    },
    created() {
        this.lang = this.$i18n.locale
        this.setEchartOption();
    },
    mounted: function () {
        // this.ByStaticJson()//通过post请求方式读取json文件，但要求json文件必须在vue工程下的static文件夹
        this.$nextTick(()=>{
            this.initMap()
        })    
    },
    methods: {
        initMap(){
            let mapDiv = document.getElementById('china_map')
            let myChart = echarts.init(mapDiv)
            myChart.setOption(this.options)
        },
            //修改echart配制
        setEchartOption(){
            const _this = this
            this.options = {
                tooltip: {
                    triggerOn: "mousemove",   //mousemove、click
                    backgroundColor:'transparent',
                    borderRadius: 4,
                    // trigger: 'axis',
                　　// 相对位置
                // 　　position: ['0%', '0%'],
                    textStyle:{
                        color:'#000000',
                        fontSize:19
                    },
                    formatter: function(e, t, n) {
                        if(!e.data || !e.data.content){
                            return ''
                        } else{
                            let data = e.data
                            if(_this.lang == 'zh'){
                                let context = `
                                <div class="tool-box">
                                    <div style="font-size:24px;line-height:24px;">${data.name}</div>
                                    <div class="map_content">
                                        <div class="map_left">
                                            <div class="map_title">面积:</div>
                                            <div class="map_item">${data.content}</div>
                                        </div>
                                        <div class="map_img">
                                            <img style="width: 163px;" src="`+ data.image1 +`">
                                        </div>
                                    </div>    
                                </div>
                                `
                                return context
                            }else if(_this.lang == 'en'){
                                let context = `
                                <div class="tool-box">
                                    <div style="font-size:24px;line-height:24px;">${data.enName}</div>
                                    <div class="map_content">
                                        <div class="map_left">
                                            <div class="map_title">Area：</div>
                                            <div class="map_item">${data.enContent}</div>
                                        </div>
                                        <div class="map_img">
                                            <img style="width: 163px;" src="`+ data.image1 +`">
                                        </div>
                                    </div>    
                                </div>
                                `
                                return context
                            }
                        }
                    }
                },
  
                geo: {
                    map: "china",
                    zoom: 2,
                    top: -10,
                    roam: true, //是否开启平游或缩放
                    scaleLimit: { //滚轮缩放的极限控制
                        min: 1,
                        max: 5
                    },
                    label: {
                        normal: {
                            show: false
                        },
                        emphasis: {
                            show: false,
                        }
                    },
                    itemStyle: {
                        normal: {
                            areaColor: "#ffffff",
                            borderColor: "rgba(0, 0, 0, 0.2)"
                        },
                        emphasis: {
                            areaColor: "#ffffff",
                            shadowOffsetX: 0,
                            shadowOffsetY: 0,
                            borderWidth: 0
                        }
                    }
                },
                series: [{
                    type: 'scatter',
                    coordinateSystem: 'geo',
                    data: this.dataList,
                    // symbol:'circle',
                    symbol: 'image://'+ require('@/assets/images/location1.svg'),
                    symbolSize: [15, 20],
                    label: {
                        normal: {
                            show: true,
                            formatter: function (params) {
                                if(_this.lang == 'zh'){
                                    return params.data.name
                                } else if(_this.lang == 'en'){
                                    return params.data.enName 
                                }
                            },
                            position: 'bottom',
                            color: '#ED6D00',
                            fontSize: '18',
                        }
                    },
                    itemStyle: {
                        color: '#ED6D00'
                    }
                }]
            }
            this.options.series[0]['data'] = this.dataList;
        }
    }
})
</script>
<style>
    #china_map {
        height: 320px;
    }
    @media screen and (max-width: 1399px) {
        #china_map {
            height: 320px;
        }
    }
    #china_map .tool-box{
        width: 381px;
        padding: 16px;
        background: #ffffff;
        color: #4C4948;
        border-radius: 4px;
        box-shadow: 0px 0px 8px 0px rgba(76, 73, 72, 0.3);
    }
    #china_map .map_title{
        font-size: 20px;
        color: #ED6D00;
        margin-top: 16px;
    }
    #china_map .map_content{
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
    }
    #china_map .map_item{
        width: 50%;
        color: #707070;
        font-size: 15px;
    }
    #china_map .item_text{
        color: #707070;
    }
    #china_map .map_left{
        min-width: 144px;
        margin-right: 8px;
    }
    #china_map .map_img{
        margin-top: 16px;
        display: flex;
        justify-content: space-between;
    }
    #china_map .map_img .img{
        width: 163px;
        /* height: 144px; */
        border-radius: 6px;
    }
</style>
<style scoped>
    .info{
        padding-left: 50px;
        margin-bottom: 20px;
        position: relative;
    }
    .title{
        font-size: 50px;
        line-height: 50px;
        color: #ED6D00;
        padding: 54px 0 45px 0;
    }
    .card-box{
        display: flex;
        flex-wrap: wrap;
    }
    .item {
        width: 25%;
        margin-right: 30px;
        font-weight: 500;
        margin-bottom: 35px;
        color: #4C4948;
    }
    .left-ball{
        width: 30px;
        height: 30px;
        background: #ED6D00;
        position: absolute;
        top: -15px;
        left: -15px;
        border-radius: 50%;
    }
    .right-ball{
        width: 30px;
        height: 30px;
        background: #ED6D00;
        position: absolute;
        top: -15px;
        right: -15px;
        border-radius: 50%;
    }
    @media screen and (max-width: 768px) {
        #china_map {
            height: 380px;
        }
        .info{
            padding:0 20px;
        }
        .title{
            font-size: 40px;
        }
        .card-box{
            justify-content: space-between;
        }
        .item {
            width: calc(50% - 10px);
            margin-right: 0px;
            font-weight: 500;
            margin-bottom: 35px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/warehousing/warehousing.vue